export * as recordOccupants from './record-occupants'
